import { Button, Box, Flex, Text, useMantineTheme, Group } from "@mantine/core";
import { useEffect } from "react";
import { useAppContext } from "src/api/AppContext";
import {
  SignedAgreementStatus,
  useGetEmbeddedLinkQuery,
  useGetSignedAgreementDocumentsQuery,
  useGetSignedAgreementOnPaymentQuery,
  useSignDocumentMutation,
} from "src/generated/graphql";
import { ModalStages } from "src/utils/constants";

interface SignPoliciesProps {
  setCurrentModalStage: (e: ModalStages) => void;
  clientId: string;
  selectedAgreementId: string;
}

// const SignPolicies = ({ setCurrentModalStage }: SignPoliciesProps) => {
//   const theme = useMantineTheme();
//   return (
//     <div
//       style={{
//         width: "100%",
//         minHeight: 500,
//         display: "flex",
//         flexDirection: "column",
//         borderRadius: 4,
//       }}
//     >
//       <Flex
//         align={"center"}
//         justify={"flex-start"}
//         style={{
//           padding: "10px 20px",
//           marginBottom: "10px",
//           borderBottom: `2px solid ${theme.colors.light[5]}`,
//         }}
//       >
//         <Text size={22} fw={500}>
//           Sign Policies
//         </Text>
//       </Flex>
//       <Flex
//         justify={"space-between"}
//         align={"center"}
//         style={{
//           position: "absolute",
//           bottom: 0,
//           left: 0,
//           margin: "20px",
//           width: "90%",
//         }}
//       >
//         <Group w={"100%"} spacing={20} align={"center"}>
//           <Button
//             radius="lg"
//             variant="outline"
//             onClick={() => setCurrentModalStage(ModalStages.AGREEMENTOVERVIEW)}
//             style={{
//               flex: 1,
//               color: theme.colors.secondaryTextColor[6],
//             }}
//             sx={{
//               backgroundColor: theme.colors.secondary[6],
//               "&:hover": {
//                 background: theme.colors.secondary[5],
//               },
//             }}
//           >
//             Back
//           </Button>
//           <Button
//             radius="lg"
//             variant="filled"
//             onClick={() => setCurrentModalStage(ModalStages.DEVICEUNLOCK)}
//             style={{
//               flex: 1,
//             }}
//             sx={{
//               color: theme.colors.primaryTextColor[6],
//               "&:hover": {
//                 backgroundColor: theme.colors.primary[4],
//               },
//             }}
//           >
//             Unlock Device
//           </Button>
//         </Group>
//       </Flex>
//     </div>
const SignPolicies = ({
  setCurrentModalStage,
  clientId,
  selectedAgreementId,
}: SignPoliciesProps) => {
  const theme = useMantineTheme();
  const { currentLocation } = useAppContext();
  const cardBg = theme.colors.primary[4];

  const { data: signedAgreement } = useGetSignedAgreementOnPaymentQuery({
    variables: {
      agreementId: selectedAgreementId,
      clientId,
      locationId: currentLocation?.id || "",
    },
    skip: !currentLocation?.id,
    fetchPolicy: "network-only",
  });
  const signedAgreementId = signedAgreement?.checkForSignedAgreement?.id;

  const { data: signedAgreementDetail } = useGetSignedAgreementDocumentsQuery({
    variables: {
      id: signedAgreementId || "",
    },
    skip: !signedAgreementId,
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    function handleMessage(event: MessageEvent) {
      if (
        event.origin === window.location.origin &&
        event.data.documentSigned
      ) {
        handleSubmit();
      }
    }
    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [signedAgreementDetail]);

  const [signDoc, { loading: signingDocLoading }] = useSignDocumentMutation({
    onCompleted() {
      setCurrentModalStage(ModalStages.DEVICEUNLOCK);
    },
  });

  const { data: link } = useGetEmbeddedLinkQuery({
    variables: { signedAgreementId: signedAgreementId! },
    skip: !signedAgreementId,
    fetchPolicy: "network-only",
  });

  const handleSubmit = async () => {
    const { status, signedDocGroup } =
      signedAgreementDetail?.signedAgreementOne || {};
    if (signingDocLoading || !signedDocGroup?.id) return;
    // if signed agreement is UnSigned then signDocument else just navigate
    if (status === SignedAgreementStatus.Unsigned) {
      await signDoc({
        variables: {
          signDocumentId: signedDocGroup!.id,
          data: {
            signee: { id: clientId },
          },
        },
      });
    }
  };

  return (
    <Flex direction={"column"} justify={"space-between"}>
      <Flex direction={"column"}>
        <Text size={22} fw={500}>
          Sign Policies
        </Text>
        <hr />

        <Box bg={"white"} w={"90vw"} h={"70vh"}>
          <iframe
            src={link?.getEmbeddedLink || ""}
            height="100%"
            width="100%"
            frameBorder={0}
            style={{ minHeight: "40vh" }}
          ></iframe>
        </Box>
      </Flex>
      <Flex justify={"space-between"} align={"center"} mt={20}>
        <Button
          w={"45%"}
          radius="lg"
          variant="outline"
          onClick={() => setCurrentModalStage(ModalStages.AGREEMENTOVERVIEW)}
        >
          Back
        </Button>
        <Button
          w={"45%"}
          radius="lg"
          variant="filled"
          disabled={
            !signedAgreementDetail ||
            signedAgreementDetail.signedAgreementOne?.status ===
              SignedAgreementStatus.Unsigned
          }
          onClick={() => setCurrentModalStage(ModalStages.DEVICEUNLOCK)}
        >
          Unlock Device
        </Button>
      </Flex>
    </Flex>
  );
};

export default SignPolicies;
